import { render } from "./ShatterButton.vue?vue&type=template&id=95d5fb44&scoped=true&ts=true"
import script from "./ShatterButton.vue?vue&type=script&lang=ts"
export * from "./ShatterButton.vue?vue&type=script&lang=ts"

import "./ShatterButton.vue?vue&type=style&index=0&id=95d5fb44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d5fb44"]])

export default __exports__